export const ONE_SECOND = 1000;

export const DEFAULT_TAB_TIMER = ONE_SECOND * 10;
